module.exports = __webpack_public_path__ + "img/veiculo-branco.d5b91ea8.png";